


















































import Vue from 'vue'

export default Vue.extend({
  props: {
    indexName: String,
    highlight: Boolean
  }
})
